import { CookieOptions, EncodeData } from '../models/cookie.model'

const useCookie = (key: string) => {
  const getCookie = () => {
    const matches = document.cookie.match(
      new RegExp(
        `(?:^|; )${key.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`
      )
    )

    return matches ? decodeURIComponent(matches[1]) : undefined
  }

  const getCookieWithEncodedData = () => {
    const encoded = getCookie()
    return encoded ? JSON.parse(encoded) : undefined
  }

  const encodeDataWithValue = (
    value: boolean | string | number,
    toEncode: EncodeData
  ) => {
    const tokenObj = Object.keys(toEncode).reduce(
      (tokenObject, key) => ({
        ...tokenObject,
        [`${key}`]: toEncode[key]
      }),
      { value }
    )
    return JSON.stringify(tokenObj)
  }

  const setCookie = (
    value: boolean | string | number,
    options: CookieOptions = {},
    toEncode?: EncodeData
  ) => {
    options = {
      path: '/',
      ...options
    }

    const tokenValue = toEncode ? encodeDataWithValue(value, toEncode) : value

    let updatedCookie = `${encodeURIComponent(key)}=${encodeURIComponent(
      tokenValue
    )}`

    Object.keys(options).forEach(key => {
      updatedCookie += `; ${key}=${options[key]}; secure`
    })

    document.cookie = updatedCookie
  }

  return {
    getCookie,
    getCookieWithEncodedData,
    setCookie
  }
}

export default useCookie
